// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.period-row {
  transition: ease-out;
  transition-duration: 120ms;
}

.period-row:hover {
  transition: none;
}
`, "",{"version":3,"sources":["webpack://./src/context/focusPeriod/periodSelector.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".period-row {\n  transition: ease-out;\n  transition-duration: 120ms;\n}\n\n.period-row:hover {\n  transition: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
